<template>
  <div v-cloak>
    <div class="vx-card mb-4">
      <div class="vx-card__collapsible-content vs-con-loading__container">
        <div class="vx-card__body card-body">
          <div class="vx-row">
            <div class="vx-col w-full">
              <form>
                <div class="vx-row mb-2">
                  <div class="vx-col lg:w-1/4 md:w-1/3 sm:w-1/2 w-full">
                    <div class="w-full">
                      <vs-input class="inputx mb-4" v-model="gridSearchData.PartyName" :label="$t('PartyName')" />
                    </div>
                  </div>
                  <div class="vx-col lg:w-1/4 md:w-1/3 sm:w-1/2 w-full">
                    <label class="vs-input--label">{{ $t("PartyType") }}</label>
                    <div class="w-full">
                      <v-select label="name" class="mb-4" :options="partyTypes" v-model="gridSearchData.PartyType"
                        :reduce="x => x.value" dir="rtl">
                      </v-select>
                    </div>
                  </div>
                  <div class="vx-col lg:w-1/4 md:w-1/3 sm:w-1/2 w-full">
                    <div class="w-full">
                      <vs-input class="inputx mb-4" v-model="gridSearchData.MinAmount" :label="$t('MinPrice')" />
                    </div>
                  </div>
                  <div class="vx-col lg:w-1/4 md:w-1/3 sm:w-1/2 w-full">
                    <div class="w-full">
                      <vs-input class="inputx mb-4" v-model="gridSearchData.MaxAmount" :label="$t('MaxPrice')" />
                    </div>
                  </div>
                  <div class="vx-col lg:w-1/4 md:w-1/3 sm:w-1/2 w-full">
                    <label class="vs-select--label datepicker-lb">{{
                      $t("FromDate")
                    }}</label>
                    <date-picker v-model="gridSearchData.MinCreateTime" type="datetime" format="jYYYY-jMM-jDD HH:mm:ss"
                      display-format="jYYYY-jMM-jDD HH:mm:ss" class="date-picker mb-4" :label="$t('FromDate')"
                      :clearable="true" />
                  </div>
                  <div class="vx-col lg:w-1/4 md:w-1/3 sm:w-1/2 w-full">
                    <label class="vs-select--label datepicker-lb">{{
                      $t("ToDate")
                    }}</label>
                    <date-picker v-model="gridSearchData.MaxCreateTime" type="datetime" format="jYYYY-jMM-jDD HH:mm:ss"
                      display-format="jYYYY-jMM-jDD HH:mm:ss" class="date-picker mb-4" :label="$t('ToDate')"
                      :clearable="true" />
                  </div>
                  <div class="lg:w-1/2 w-full mt-6 px-2">
                    <vs-button type="filled" class="float-right" @click.prevent="submitFilter()">{{ $t("SubmitFilter")
                    }}</vs-button>
                    <vs-button type="filled" class="float-right ml-4" id="reset-btn" @click.prevent="resetForm">{{
                      $t("ResetFilter") }}</vs-button>
                  </div>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="vx-card mb-4">
      <div class="vx-card__collapsible-content vs-con-loading__container">
        <div class="vx-card__body card-body">
          <div class="vx-row mb-6">
            <div class="vx-col w-full">
              <vs-button @click="downloadFile()" class="bg_purple float-right mr-4">
                <feather-icon icon="PlusIcon" svgClasses="h-4 w-4" class="ico" />
                {{ $t("DownloadExcelFile") }}
              </vs-button>
            </div>
          </div>
          <div class="vx-row ">
          <div class="vx-col w-full mb-base order-grid-container">
              <data-grid id="orderGrid" ref="grid" stripe :data-source="gridDataSource"
                :show-sum="true" :show-sum-of-all="true" :search-data="gridSearchData" :columns="[
                  { title: $t('PartyName'), name: 'PartyName' },
                  { title: $t('OrderId'), name: 'OrderId' },
                  { title: $t('PartyType'), name: 'PartyType' },
                  { title: $t('SalePersonFullName'), name: 'SalePersonFullName' },
                  { title: $t('ContractName'), name: 'ContractName' },
                  {
                    title: $t('TotalAmountForPayment'),
                    name: 'TotalAmountForPayment',
                    total: 'TotalOfTotalAmountForPayment'
                  },
                  { title: $t('CreateOn'), name: 'CreateOn' },
                  { title: $t('Action'), name: 'Action' }
                ]">
                <template slot-scope="{ row }">
                  <td style="width: 15%">
                    {{ row.orderPartyInfoQueryDto.name }}
                  </td>
                  <td style="width: 10%">
                    {{ row.id }}
                  </td>
                  <td style="width: 15%">
                    {{ row.orderPartyInfoQueryDto.partyType }}
                  </td>
                  <td style="width: 15%">
                    {{ row.orderSalePersonInfo.name }}
                  </td>
                  <td style="width: 15%">
                    {{ row.orderContractQuery.contractTitle }}
                  </td>
                  <td style="width: 17%">
                    {{ Number(row.totalAmountForPayment).toLocaleString() }}
                    ریال
                  </td>
                  <td style="width: 15%">
                    {{ row.createOn.split(" ")[0] }}<br />{{
                      row.createOn.split(" ")[1]
                    }}
                  </td>
                  <td style="width: 10%">
                    <router-link :to="{ path: '/Order/Details/' + row.id }" target="_blank">
                      <vs-button radius color="success" size="small" type="gradient" icon-pack="feather" icon="icon-eye"
                        class="ml-4 d-inline"></vs-button>
                    </router-link>
                  </td>
                </template>
              </data-grid>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<style lang="scss">
#reset-btn {
  margin-left: 1.5rem;
  background: #3ec9d6 !important;
}

.order-grid-container .vs-con-tbody {
  overflow-x: auto;
  max-width: 100%;
}

.order-grid-container .total-row td {
  position: sticky !important;
  background-color: #007470 !important;
  color: #fff !important;
  z-index: 10;
  white-space: nowrap;
}

.order-grid-container .total-row:not(:last-child) td {
  bottom: 40px !important;
}

.order-grid-container .total-row:last-child td {
  bottom: 0 !important;
  z-index: 11;
}
</style>
<script>
import "@/assets/scss/vuesax-rtl/pages/_custom.scss";
import DataGrid from "@/components/datagrid/DataGrid";
import vSelect from "vue-select";
import VuePersianDatetimePicker from "vue-persian-datetime-picker";
import { mapActions } from "vuex";
import utils from "@/assets/utils/index";

export default {
  props: {
    contractId: {
      default: {}
    }
  },
  data() {
    return {
      gridDataSource: {
        type: "app",
        service: "Sales/api/OrdersQuery"
      },
      gridSearchData: {
        ContractId: this.contractId
      },
      partyTypes: [
        { name: "حقیقی", value: "Individual" },
        { name: "حقوقی", value: "Legal" }
      ]
    };
  },
  methods: {
    ...mapActions({
      exportOrderQueryExcel: "excel/exportOrderQuery"
    }),
    submitFilter() {
      this.$refs.grid.renderGrid(1, true);
    },
    resetForm() {
      this.gridSearchData = {
        PartyName: "",
        PartyType: "",
        ContractId: this.contractId,
        MinAmount: "",
        MaxAmount: "",
        MinCreateTime: "",
        MaxCreateTime: ""
      };
      setTimeout(() => {
        this.$refs.grid.renderGrid(1, true);
      }, 0);
    },
    downloadFile() {
      var params = utils.toQueryString(this.gridSearchData);
      this.exportOrderQueryExcel(params);
    }
  },
  components: {
    DataGrid,
    "v-select": vSelect,
    datePicker: VuePersianDatetimePicker
  }
};
</script>
